import { CollectionLockupFragment } from "@opensea/app-kit"
import { graphql } from "@opensea/graphql"
import { getItemQuoteResultErrorFragment } from "./getItemQuoteResultError.fragment"

export const QuoteReceiptRowFragment = graphql(
  `
    fragment QuoteReceiptRow on ItemQuoteResult {
      __typename
      ... on WithQuoteItem {
        item {
          id
          # TODO - move this to PricingLookup fragment
          contractAddress
          tokenId
          chain {
            identifier
          }
          isFungible
          imageUrl
          name
          collection {
            ...CollectionLockup
          }
        }
      }
      ... on ItemQuote {
        pricePerItem {
          token {
            unit
            symbol
          }
          usd
        }
        quantity
        marketplace {
          identifier
        }
      }

      ... on ItemNotFound {
        item {
          tokenId
          chain {
            identifier
          }
          contractAddress
        }
        __typename
      }

      ...getItemQuoteResultError
    }
  `,
  [getItemQuoteResultErrorFragment, CollectionLockupFragment],
)
